import { Box, TableCell, TableRow, Typography } from "@material-ui/core";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import Highcharts from "highcharts";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import { EXPLORER_TYPE } from "src/hooks/useExplorerUrl";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";

export default function DesktopTransactionRow({ rowData, pool, isFullTable = true }) {
  return (
    <TableRow>
      <TableCell colSpan={2}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Brightness1Icon style={{ color: rowData["color"], fontSize: "16px", marginRight: "0.25rem" }} />
          <Typography>{rowData.type}</Typography>
        </Box>
      </TableCell>
      <TableCell colSpan={3}>
        <Typography>{Highcharts.dateFormat("%b %e, %Y, %k:%M", rowData.timestamp)}</Typography>
      </TableCell>
      <TableCell colSpan={2}>
        <Typography>{`$${numberWithCommas(toFixed(rowData.amount, 2))}`}</Typography>
      </TableCell>
      {isFullTable && (
        <>
          <TableCell colSpan={2}>
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography>{rowData.symbol}</Typography>
              <ExternalLinkButton hash={rowData.token} config={{ pool }} />
            </Box>
          </TableCell>
          <TableCell colSpan={2}>
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography>{formatAddress(rowData.transaction, 3)}</Typography>
              <ExternalLinkButton hash={rowData.transaction} config={{ pool, type: EXPLORER_TYPE.TRANSACTION }} />
            </Box>
          </TableCell>
        </>
      )}
    </TableRow>
  );
}
